<template>
  <div class="page">
    <div class="app-container">
      <!-- 搜索 -->
      <BaseSearch
        v-model="searchData"
        :formOptions="searchFormOption"
        @handleSearch="handleSearch"
      ></BaseSearch>
      <el-button type="primary" @click="handleExport">导出</el-button>
      <BaseTable
        ref="baseTable"
        url="/admin/syslog/index"
        :tableData.sync="tableData"
        :columns="columns"
        :searchParams="searchData"
      ></BaseTable>
      <el-drawer
        :title="drawerCfg.title"
        :visible.sync="drawerCfg.visible"
        :direction="drawerCfg.direction"
        :size="drawerCfg.size"
        :before-close="drawerBeforeClose"
        @close="drawerClose"
      >
        <BaseForm v-model="formData" :formOptions="editFormOption"></BaseForm>
      </el-drawer>
    </div>
  </div>
</template>

<script>
import { searchFormOption, editFormOption } from "./formOptions";
import { columns } from "./columns";

export default {
  name: "Log",
  comments: {},
  data() {
    return {
      tableData: [],
      searchData: {},
      formData: {},
      drawerCfg: {
        title: "新建",
        visible: false,
        direction: "rtl",
        size: "40%",
      },
      selectOption: [],
      cascaderOption: [],
    };
  },
  computed: {
    columns,
    searchFormOption,
    editFormOption,
  },
  created() {},
  methods: {
    // 点击导出
    async handleExport() {
      const res = await this.$api.get("/admin/syslog/exportExcel", {}, "导出");
      console.log(res);
      window.open("https://" + res.data);
      // location.href = 'https://billing.xiaoxiaocx.com/uploads/20211215/170016.xlsx'
    },
    // 点击搜索
    handleSearch() {
      console.log(this.searchData);
      this.$refs.baseTable.searchData();
    },
    // 搜索参数拦截
    paramsCepCallback(params) {
      console.log(params);
      return {
        ...params,
        ...this.searchData,
        beginDate: this.searchData.dateList[0],
        endDate: this.searchData.dateList[1],
      };
    },
    //弹框关闭之前
    drawerBeforeClose() {},
    // 弹框关闭
    drawerClose() {},
  },
};
</script>
